export default {
  GET_TOWN_RAIN: 'GET_TOWN_RAIN',
  GET_RES_OVERFLOW: 'GET_RES_OVERFLOW',
  GET_WATER_OVERFLOW: 'GET_WATER_OVERFLOW',
  GET_WARN_VILLAGE: 'GET_WARN_VILLAGE',
  GET_RAINLY_SEASON_RAINFALL: 'GET_RAINLY_SEASON_RAINFALL',
  GET_PROJECT_GATES: 'GET_PROJECT_GATES',
  GET_ANALYTICAL_RAIN: 'GET_ANALYTICAL_RAIN',
  SAVE_ONE_RAIN_WATER_NOTICE: 'SAVE_ONE_RAIN_WATER_NOTICE'
}
